<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">
        User Information
      </h1>
      <router-link
        :to="`/user/edit/${$route.params.id}`"
        class="button is-small is-primary is-uppercase"
        >Edit</router-link
      >
    </div>
    <div class="box">
      <table class="table is-fullwidth">
        <tr>
          <th>Employee ID</th>
          <td>{{ user.employeeId }}</td>
        </tr>
        <tr>
          <th>Name</th>
          <td>{{ user.name }}</td>
        </tr>
        <tr>
          <th>Mobile</th>
          <td>{{ user.mobile }}</td>
        </tr>
        <tr>
          <th>Email</th>
          <td>{{ user.email }}</td>
        </tr>
        <tr>
          <th>Role</th>
          <td>
            <span
              class="is-uppercase"
              :class="{ 'has-text-success': user.role === 'admin' }"
              >{{ user.role }}</span
            >
          </td>
        </tr>
        <tr>
          <th>Active</th>
          <td>
            <span
              class="is-uppercase"
              :class="{ 'has-text-success': user.active }"
              >{{ user.active ? "Active" : "Inactive" }}</span
            >
          </td>
        </tr>
      </table>

      <div class="is-flex">
        <div class="is-expanded">
          <router-link to="/user" class="button is-borderless"
            >Back</router-link
          >
        </div>
        <div class="is-expanded has-text-right"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: {}
    };
  },
  mounted() {
    let component = this;
    component.$store
      .dispatch("user/show", component.$route.params.id)
      .then(response => {
        component.user = response.data;
      });
  }
};
</script>
